import React from 'react'
import PropTypes from 'prop-types'
import Settings from '@mui/icons-material/Settings'

const SettingsIcon = ({ height, width, ...more }) => {
	
	return (
		<Settings
			height={height}
			width={width}
			{...more}
		/>
	)
}

SettingsIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default SettingsIcon
